export default __webpack_public_path__ + "static/arthrscopy-set-up-8b5fe2b9a59081cfe8af1e5aa1dc57aa.jpg";